import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[appFormatSerie]'
})
export class FormatSerieDirective {

  constructor(private ctrl: NgControl) { }
  @HostListener('keyup')
  @HostListener('paste', ['$event'])
  onKeyUp(event: Event) {
    const serieOriginal = this.ctrl.value;
    const serieFormat = this.transform(serieOriginal);
    if (serieOriginal !== serieFormat) {
      
      this.ctrl.control.setValue(serieFormat);
      event.stopPropagation();
    }
  }
  transform(value: string): string {
    let cleanValue = value.replace(/[^(a-zA-Z0-9)]/g, '');

    if (cleanValue.startsWith('a') || cleanValue.startsWith('A')) {
      value = cleanValue.slice(0, 10);
      return value.toUpperCase();
    } else {
      value = cleanValue.slice(0, 9);
      return value.replace(/^([a-zA-Z0-9]{3})([a-zA-Z0-9]{3})([a-zA-Z0-9]{3})$/, '$1.$2.$3');

    }
  }
}